import * as e from "react";
const o = (c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...c
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.875 18.31v1.872H15.5c.483 0 .875.407.875.909S15.983 22 15.5 22h-7c-.483 0-.875-.407-.875-.91 0-.501.392-.908.875-.908h2.625v-1.873c-3.5-.458-6.126-3.552-6.125-7.218 0-.502.392-.91.875-.91s.875.408.875.91c0 2.824 2.066 5.147 4.713 5.426.177.019.356.029.537.029 2.9 0 5.25-2.443 5.25-5.455 0-.502.392-.91.875-.91s.875.408.875.91c.001 3.666-2.624 6.76-6.125 7.218zM8.5 11.09c0 2.01 1.567 3.637 3.5 3.637.12 0 .24-.006.358-.018 1.765-.187 3.142-1.735 3.142-3.618V5.636C15.5 3.628 13.933 2 12 2S8.5 3.628 8.5 5.636v5.455zm5.25-5.454c0-1.004-.784-1.818-1.75-1.818s-1.75.814-1.75 1.818v5.455c0 1.004.784 1.818 1.75 1.818s1.75-.814 1.75-1.818V5.636z",
      fill: "#2d6ded"
    }
  )
), t = o;
export {
  t as default
};
